export default "__VITE_ASSET__G7OEYHjKkuF9sexiWM$FJA__"